<template>
  <Modal width="496" v-model.trim="cForm.modal" title="设置" @on-ok="submit">
    <Form
      class="c-form c-form--modal"
      ref="form"
      :model="cForm.model"
      :rules="cForm.rules"
      :label-width="80"
    >
      <Form-item label="标题" prop="name">
        {{ $helpers.getItem(dicts.TxtFormat, "value", moduleName)["label"] }}
      </Form-item>
      <Form-item label="文本" prop="text">
        <Input
            class="c-form__input"
            v-model.trim="cForm.model.text"
            placeholder="请输入标题文本"
            />
      </Form-item>
    </Form>
  </Modal>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import FormMixin from "view-ui-admin/src/mixins/form";

@Component({
  mixins: [FormMixin],
  props: {
    formModel: {
      type: Object,
      default: () => ({})
    }
  }
})
export default class extends Vue {
  data() {
    return {
      moduleName: "",
      cForm: {
        id: 0,
        modal: false,
        model: this.getFormInitModel(),
        rules: {}
      }
    };
  }

  getFormInitModel() {
    return {
      text: "",
    };
  }

  show(row) {
    const moduleName = row.value;
    const { txtformat: modules } = this.formModel;

    this.moduleName = row.value;
    this.cForm.modal = true;
    if (modules && modules[moduleName]) {
      this.cForm.model.text = modules[moduleName].text;
    } else {
      this.cForm.model.text = this.cForm.label;
    }
  }

  submit() {
    const { txtformat } = this.formModel;

    if (!txtformat) {
      this.formModel.txtformat = {};
    }

    this.$set(
      this.formModel.txtformat,
      this.moduleName,
      this.$helpers.deepCopy(this.cForm.model)
    );

    this.$Message.info("设置成功，保存表单后生效");
  }
}

</script>
